export default "__VITE_PUBLIC_ASSET__f46258a5__"